import { FF_ENABLE_SHOPIFY_PAYMENT } from '@/constants/featureFlags';
import { useFeatureFlags } from '@/hooks';
import type { ConsultPaymentState } from '@/hooks/consult/useConsult';
import { Alert, AlertTitle, Typography } from '@mui/material';

interface PaymentInfoTextProps {
  consultPaymentState: ConsultPaymentState;
  hasBeenInvoicedByEway: boolean;
}

export const PaymentInfoText = ({ consultPaymentState, hasBeenInvoicedByEway }: PaymentInfoTextProps) => {
  const { flags } = useFeatureFlags();
  const ffEnableShopifyPayment = flags[FF_ENABLE_SHOPIFY_PAYMENT];

  switch (consultPaymentState) {
    case 'IN_PROGRESS':
      return (
        <Alert severity={'info'}>
          <AlertTitle>The patient&apos;s consultation payment is pending.</AlertTitle>
          {ffEnableShopifyPayment && !hasBeenInvoicedByEway ? (
            <Typography variant="body2">
              The patient has received an email with a secure checkout link to complete their payment.
            </Typography>
          ) : (
            <Typography variant="body2">
              Please click the &quot;Resend Invoice&quot; button to generate and send a new copy of the payment invoice
              to the patient.
            </Typography>
          )}
        </Alert>
      );
    case 'PAID':
      return (
        <Alert severity={'success'}>
          <AlertTitle>The patient&apos;s consultation payment has been successfully processed.</AlertTitle>
          {!ffEnableShopifyPayment && (
            <Typography variant="body2">
              If needed, click the &quot;Resend Invoice&quot; button to generate and send a new copy of the payment
              receipt to the patient.
            </Typography>
          )}
        </Alert>
      );
    case 'NOT_PAID':
    default:
      return (
        <>
          <Typography variant="body2" fontWeight={500} display={'inline'}>
            All patients will be automatically charged for the consultation when the &quot;Complete Consultation&quot;
            button is selected.{' '}
          </Typography>
          <Typography variant="body2" display={'inline'}>
            If the consultation is complimentary select &quot;Complimentary Consultation&quot;. Please note that
            concession and other eligible discounts will be applied automatically
          </Typography>
        </>
      );
  }
};
